<template>
    <v-card class="elevation-12" color="grey darken-4" dark>

      <v-card-text v-if="success">
        <v-row>
            <v-col class="d-flex justify-center">
                <v-img src="/img/logo.png" contain max-width="240"/>
            </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center">
            Check your mail, and follow instructions
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-else>
        <v-row>
            <v-col class="d-flex justify-center">
                <v-img src="/img/logo.png" contain max-width="240"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-progress-linear
                    v-if="loading"
                    :indeterminate="true"
                    color="accent"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-alert
                    :value="message"
                    type="error"
                    dismissible
                    transition="scale-transition"
                    v-if="message && message.length > 0"
                >{{ message.join() }}</v-alert>
            </v-col>
        </v-row>
        <v-form>
            <v-row>
                <v-col>
                    <v-text-field prepend-icon="mdi-account" v-model="email" label="Email" type="text"></v-text-field>
                </v-col>
            </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="!success">
        <v-btn outlined to="/login">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn outlined color="accent" v-on:click="doReset()" type="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </template>
  <script>
  import { mapActions, mapGetters } from 'vuex';
  export default {
    components: {},
    data: () => ({
      email: null,
      success: null,
    }),
    computed: {
    ...mapGetters('auth', ['loading'])
    },
    methods: {
    ...mapActions('auth', ['forgotPassword']),
      doReset() {
        this.forgotPassword({ email: this.email })
        .then(() => this.success = true)

      }
    }
  };
  </script>
  
  <style></style>
  